module.exports = __webpack_public_path__ + "assets/media/2.56b45436.wav";